module.exports = [
  {
    default: true,
    prefix: '',
    locale: 'fr',
    home: '/',
    label: 'Français',
    shortLabel: 'FR',
    prismicLocale: 'fr-fr',
    slugs: {
      offers: 'nos-offres',
      blog: 'actualites',
      aboutUs: 'qui-sommes-nous'
    }
  },
  {
    prefix: '/en',
    locale: 'en',
    home: '/en',
    label: 'English',
    shortLabel: 'EN',
    prismicLocale: 'en-gb',
    slugs: {
      offers: 'our-offers',
      blog: 'news',
      aboutUs: 'about-us'
    }
  }
]
